import React, { useRef, useEffect, useContext } from "react";
import styled from "styled-components";
import $ from "jquery";
import Loader from "../Loader/Loader";
import { ProductOptionRefContext } from "../../Providers/ProductOptionRefProvider";
import { TranslationContext } from "../../Providers/TranslationProvider";

// const StyledCard = styled.div`
//     margin-bottom: 30px;
//     position: relative;
// `;

// const TitleCon = styled.div`
//     border-bottom: 1px solid #f4f4f4;
//     padding: 18px 20px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
// `;

// const Btn = styled.button`
//     border: 1px solid #4a4a4a;
//     padding: 8px 12px;
//     background-color: transparent;
//     border-radius: 4px;
//     transition: all 0.2s ease-in-out;
//     cursor: pointer;

//     &:hover {
//         background-color: #4a4a4a;
//         color: white;
//     }
// `;

// const LoadingCon = styled.div`
//     position: absolute;
//     top: 0;
//     bottom: 0;
//     left: 0;
//     right: 0;
//     background-color: rgba(0, 0, 0, 0.3);
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 999;
// `;

const Card = ({
    children,
    onOpenInfoModal,
    title,
    topActionFunction,
    topActionFunctionPrices,
    type,
    loading,
    footerActionFunction,
    footerActionTitle,
    topActionTitle
}) => {
    const { trans } = useContext(TranslationContext);

    const { typeToScroll, clearTypeToScroll } = useContext(
        ProductOptionRefContext
    );
    const cardRef = useRef(null);

    useEffect(() => {
        if (typeToScroll === type) {
            clearTypeToScroll();
            scrollToCard();
        }
    }, [clearTypeToScroll, scrollToCard, type, typeToScroll]);

    const scrollToCard = () =>
        window.scrollTo({
            left: 0,
            top: cardRef.current.offsetTop - 150,
            //top: cardRef.current.offsetTop - $(".app-header").height() - 24,
            behavior: "smooth"
        });
    return (
        <div className="relative" ref={cardRef}>
            {children}
            {loading && (
                <div className="inset-0 black-overlay-2 absolute flex justify-center items-center">
                    <div className="flex flex-col items-center">
                        <Loader />
                        <h2 className="font-bold">Productopties aan het laden</h2>
                    </div>
                </div>
            )}
            {/* {loading && (
                <LoadingCon>
                    <Loader />
                </LoadingCon>
            )}

            <TitleCon>
                <h6 className="no-margin bold">{title}</h6>
                {topActionFunctionPrices && (
                    <div>
                        <button
                            onClick={topActionFunctionPrices}
                            className="clear button primary no-margin"
                        >
                            Levervoorwaarden
                        </button>
                    </div>
                )}
                {topActionFunction ? (
                    <div>
                        <button
                            onClick={onOpenInfoModal}
                            className="clear button primary no-margin"
                        >
                            {trans("info", true)}
                        </button>
                        <button
                            onClick={topActionFunction}
                            className="clear button primary no-margin"
                        >
                            {topActionTitle}
                        </button>
                    </div>
                ) : null}
            </TitleCon>
            <div className="card-section">
                <div className="grid-x grid-padding-x grid-margin-y">
                    {children}
                </div>
                {footerActionFunction && (
                    <div className="row center-xs">
                        <div className="col-xs-12">
                            <Btn onClick={footerActionFunction}>
                                {footerActionTitle}
                            </Btn>
                        </div>
                    </div>
                )}
            </div> */}
        </div>
    );
};

export default Card;
